export default {
      id: "menu-close-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#menu-close",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-close.svg
// module id = 134
// module chunks = 241 242 243